const DEF_VALIDATOR = /^.*[\w\u00C0-\u00FF]{3,}.*$/;

function validateEmail(input: string): boolean {
    return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]{2,63}$/.test(input);
}

export { DEF_VALIDATOR, validateEmail };
